import React from 'react';
import FormManager from '../../../../../../core/gd-form/common/form-manager';
import Textarea from '../../../../../../core/gd-form/form-element/textarea/textarea';
import Button from "../../../../../gd-components/buttons/gd-button/gd-button-ui5-new";

type Props = {
    text    : string | null
    onSave  : callback
}

export default function FieldTextEditForm(props: Props) {

    const onSubmit = (result: any) => {
        if(props.onSave) props.onSave(result.text);
    };

    const initFormData = {
        text: props.text
    };

    const formStructure = {
        fields: {
            text: {
                type: 'input',
                isRequired: false
            }
        },
        onSubmit: onSubmit
    };

    const form = new FormManager(formStructure, initFormData);

    return (
        <div className="text-edit-form">
            <Textarea className="text-edit-form-textarea"
                      size="big"
                      form={form}
                      name="text"
                      noResizeControl={true}
                      autoFocus={true}/>

            <Button className="flex-row-center-center w-80 m-h-auto m-t-5"
                    type='primary'
                    size="30"
                    label="Save"
                    onClick={() => form.onSubmitClick()}/>
        </div>
    );
}
